export default __webpack_public_path__ + "static/media/spinning.fe66af53.svg";